/*******************************************************************************
* @ngdoc   service
* @module  csm.books.AddChangeSystemLoginDialog
* @name    csm.books.AddChangeSystemLoginDialog:SystemLoginServices
* @description
* Service connection to the server.
*******************************************************************************/
/* @ngInject */ export function SystemLoginServicesProvider() {
  this.httpServiceBase = '/books/systemLoginServices/';
  this.httpServices = {
    authenticateOAuth: function (state, code) {
      return this.post('authenticateOAuth', { state, code });
    },
    authenticateUser: function (orgID) {
      return this.post('authenticateUser', orgID);
    },
    getOrganizationRoles: function (orgID) {
      return this.get('getOrganizationRoles/{0}'.format(orgID || 0));
    },
    reset: function (token, pass) {
      return this.post('resetComplete', { token, pass });
    },
    resetPassword: function (username) {
      return this.get('resetPassword/{0}'.format(username));
    },
    resetRetries: function (id) {
      return this.get('resetRetries/{0}'.format(id));
    },
    viewChartOfAccounts: function (entityID) {
      return this.get('viewChartOfAccounts/{0}'.format(entityID || 0));
    }
  };

  /**
   * @ngdoc       service
   * @name        ReceiptsService
   * @module      csm.books.WriteReceipts
   * @description Receipts controller services.
   */
  this.$get = ['HTTPService', function (HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
}

SystemLoginServicesProvider.$inject = [];